module.exports = __webpack_public_path__ + "assets/img/banner.2ce95446.png";